import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import IntroAboutUs from "../Components/AboutUs/IntroAboutUs";
import OurVision from "../Components/AboutUs/OurVision";
import WhatWeDo from "../Components/AboutUs/WhatWeDo";

import { aboutMock } from "../../Model/aboutusdymyData";
import TeamGroupCarousel from "../Components/AboutUs/TeamGroupSection";
import { AboutUsService } from "../../Logic/AboutUsService";

const AboutUsPage: React.FC = () => {
  const data = aboutMock;
  const { hash: currentLocationHash } = useLocation();

  const aboutUsService = new AboutUsService();

  useEffect(() => {
    aboutUsService.scrollToVision("vision", currentLocationHash);
  }, [currentLocationHash]);

  return (
    <main data-testid="about-page">
      <section data-testid="about-intro-section">
        <IntroAboutUs data={data.intro} once triggerAmount={0.3} />
      </section>

      <section id="vision" data-testid="about-vision-section">
        <OurVision data={data.vision} once={false} triggerAmount={0.3} />
      </section>

      <section data-testid="about-wwd-section">
        <WhatWeDo data={data.whatWeDo} once={false} triggerAmount={0.3} />
      </section>

      {/* <section data-testid="about-team-section">
        <TeamGroupCarousel groups={data.teamGroups} className="" />
      </section> */}
    </main>
  );
};

export default AboutUsPage;
